import * as React from "react"
import cn from "classnames"
import "./typography.css"

export type TypographyProps = {
    as?: string
    className?: string
    children?: React.ReactNode
}

function classTag<T, K = unknown>(defaultTag: string, baseClassName: string, additionalProps: T) {
    return ({ as: asTag = defaultTag, className, children, ...rest }: TypographyProps & K) =>
        React.createElement(
            asTag,
            {
                ...rest,
                ...additionalProps,
                className: cn(baseClassName, className),
            },
            children
        )
}

export const BottomPanelHeader = classTag("h5", "typography__header-bottom-panel", {
    role: "heading",
    "aria-level": 5,
})
export const PanelSectionHeader = classTag("h6", "typography__header-perimeter-section", {})
export const Subtitle6 = classTag("span", "typography__subtitle6", {})
export const TextSmall = classTag("span", "typography__text-small", {})
export const P = classTag("p", "", {})
export const Emphasis = classTag("em", "", {})
export const Strong = classTag("strong", "", {})
export const Link = classTag("a", "", {})
export const Underline = classTag("u", "", {})
export const Button = classTag<
    Record<string, never>,
    React.ButtonHTMLAttributes<HTMLButtonElement>
>("button", "typography__button", {})
export const TutorialHeader = classTag("h6", "typography__tutorial-header", {})
export const TutorialText = classTag<
    object,
    React.HTMLAttributes<HTMLDivElement> & {
        style?: React.HTMLAttributes<HTMLDivElement>["style"] & {
            "--typography-brand-color"?: string
        }
    }
>("div", "typography__tutorial-text", {})
export const ButtonTableAction = classTag<object, React.ButtonHTMLAttributes<HTMLButtonElement>>(
    "button",
    "typography__btn-table-action",
    {}
)
export const CommonTranslationTags = {
    p: <P />,
    em: <Emphasis />,
    strong: <Strong />,
    u: <Underline />,
}

// OLD STUFF ABOVE

export function Hyperlink({
    title,
    href,
    disabled,
}: {
    title: string
    href: string
    disabled?: boolean
}) {
    return (
        <a
            href={disabled ? "javascript:void(0)" : href}
            className={cn({
                "cursor-default": disabled,
            })}
        >
            <small
                className={cn("select-none underline", {
                    "text-gray-100 hover:text-blue-500": !disabled,
                    "text-blue-700": disabled,
                })}
            >
                {title}
            </small>
        </a>
    )
}
